import { BiCalendarX } from "react-icons/all";
import {Box, MenuItem, useColorModeValue} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { Icon } from "components/Icon";
import { ChakraText } from "components/ChakraText";
import { useGetThemeColors } from "ChakraTheme";

interface IProps {
  closeMenu: () => void;
}

const HistoricalAppointmentsMenuItem = ({ closeMenu }: IProps) => {
  const colors = useGetThemeColors();
  const iconColor = useColorModeValue(colors.black, colors.white);
  const { friendlyUrl } = useGetFriendlyUrl();
  const history = useHistory();

  return (
    <Box id="logged-user-menu-historical-appointments-btn">
      <MenuItem
        icon={<Icon color={iconColor} w={5} h={5} icon={BiCalendarX} />}
        onClick={() => {
          history.push(
            `/e-rezerwacja/${friendlyUrl}/uzytkownik/historyczne-wizyty`
          );
          closeMenu();
        }}
      >
        <ChakraText>Historyczne wizyty</ChakraText>
      </MenuItem>
    </Box>
  );
};

export { HistoricalAppointmentsMenuItem };
